import NavControlsLargeComponent from './nav-controls-large.component'

export default NavControlsLargeComponent
